import React from "react";
import { Box, Typography } from "@mui/material";

const PageHeader = ({ title, subtitle, icon, actions, gradient, sx = {} }) => {
  if (gradient) {
    return (
      <Box
        sx={{
          background: "linear-gradient(135deg, #1e3c72 0%, #2a5298 50%, #667eea 100%)",
          borderRadius: { xs: "14px", sm: "20px" },
          p: { xs: 2.5, sm: 4 },
          mb: { xs: 2, sm: 3 },
          color: "#fff",
          display: "flex",
          alignItems: { xs: "flex-start", sm: "center" },
          justifyContent: "space-between",
          flexDirection: { xs: "column", sm: "row" },
          gap: { xs: 1.5, sm: 2 },
          boxShadow: "0 8px 32px rgba(30, 60, 114, 0.3)",
          position: "relative",
          overflow: "hidden",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0, right: 0,
            width: "40%", height: "100%",
            background: "radial-gradient(circle at 80% 50%, rgba(255,255,255,0.08) 0%, transparent 60%)",
            pointerEvents: "none",
          },
          ...sx,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 1.5, sm: 2 }, zIndex: 1 }}>
          {icon && (
            <Box sx={{
              display: "flex", alignItems: "center", justifyContent: "center",
              width: { xs: 40, sm: 52 }, height: { xs: 40, sm: 52 }, borderRadius: { xs: "10px", sm: "14px" },
              bgcolor: "rgba(255,255,255,0.15)",
              backdropFilter: "blur(8px)",
              fontSize: { xs: 20, sm: 26 },
            }}>
              {icon}
            </Box>
          )}
          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: { xs: "1.15rem", sm: "1.6rem" }, lineHeight: 1.3 }}>
              {title}
            </Typography>
            {subtitle && (
              <Typography sx={{ color: "rgba(255,255,255,0.7)", mt: 0.5, fontSize: { xs: "0.8rem", sm: "0.9rem" } }}>
                {subtitle}
              </Typography>
            )}
          </Box>
        </Box>
        {actions && <Box sx={{ display: "flex", gap: 1, flexShrink: 0, zIndex: 1, width: { xs: "100%", sm: "auto" }, justifyContent: { xs: "flex-end", sm: "flex-start" } }}>{actions}</Box>}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: { xs: "flex-start", sm: "center" },
        justifyContent: "space-between",
        flexDirection: { xs: "column", sm: "row" },
        gap: { xs: 1.5, sm: 2 },
        mb: { xs: 2, sm: 3 },
        pb: { xs: 2, sm: 2.5 },
        borderBottom: "2px solid #f0f0f5",
        ...sx,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 1, sm: 1.5 } }}>
        {icon && (
          <Box
            sx={{
              display: "flex", alignItems: "center", justifyContent: "center",
              width: { xs: 38, sm: 48 }, height: { xs: 38, sm: 48 }, borderRadius: { xs: "10px", sm: "14px" },
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "#fff", fontSize: { xs: 18, sm: 24 },
              boxShadow: "0 4px 12px rgba(102, 126, 234, 0.3)",
            }}
          >
            {icon}
          </Box>
        )}
        <Box>
          <Typography
            variant="h5"
            sx={{ fontWeight: 700, color: "#1a1a2e", fontSize: { xs: "1.1rem", sm: "1.5rem" }, lineHeight: 1.3 }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" sx={{ color: "#8b8fa3", mt: 0.25, fontSize: { xs: "0.8rem", sm: "0.875rem" } }}>
              {subtitle}
            </Typography>
          )}
        </Box>
      </Box>
      {actions && <Box sx={{ display: "flex", gap: 1, flexShrink: 0, width: { xs: "100%", sm: "auto" }, justifyContent: { xs: "flex-end", sm: "flex-start" } }}>{actions}</Box>}
    </Box>
  );
};

export default PageHeader;
